// src/axios.js
import axios from 'axios';
import router from './router';

// 创建 Axios 实例
const instance = axios.create({
    // 设置api地址
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 100000,  // 请求超时设置
});

// 请求拦截器：在请求发送前自动加上 Authorization token
instance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token'); // 从本地存储获取 token
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; // 在请求头部带上 token
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器：自动获取返回的 Authorization 并保存
instance.interceptors.response.use(
    response => {
        // 检查响应数据中的 code 字段
        if (response.data.code !== 0) {
            if(response.data.code === 450) {
                // 跳转到登录页面
                router.push('/login');
            }
            // 根据实际需要抛出具体错误
            return Promise.reject(new Error(response.data.msg || '请求失败'));
        }

        const token = response.headers['authorization']; // 获取返回头部中的 Authorization
        if (token) {
            localStorage.setItem('token', token); // 将 token 保存到本地存储
        }

        return response.data;
    },
    error => {
        return Promise.reject(error);
    }
);

// 原来的地址
const oldInstance = axios.create({
    // 设置api地址
    baseURL: 'http://shkjgw.shkjem.com/api/',
    timeout: 5000,  // 请求超时设置
});

// 将 axios 的静态方法 all 和 spread 添加到自定义实例上
instance.all = axios.all;
instance.spread = axios.spread;

oldInstance.all = axios.all;
oldInstance.spread = axios.spread;

export {instance, oldInstance};
